
import { Component, Vue } from 'vue-property-decorator'
import SearchCarousel from '@/components/SearchCarousel.vue'
import MapIndex from '@/modules/search/MapIndex.vue'
import eventBus from '@/plugins/eventBus'
@Component({
  components: { MapIndex, SearchCarousel },
})
export default class Index extends Vue {
  searchString: string = ''
  selectedTab: string = 'products'
  mounted() {
    eventBus.$on('switch:tabs', (selectedTab: string) => {
      return (this.selectedTab = selectedTab)
    })
    if (process.env.VUE_APP_SHOW_SEARCH == 1) {
      window.location.href = '/search.html'
    } else window.location.href = '/'
  }
  searchData: any = [
    //lista e pergjithshem
    {
      name: 'Molle',
      related: [
        {
          image: 'http://lorempixel.com/400/400/food/2',
          name: 'Molle 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/',
          name: 'Molle 2',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/1',
          name: 'Molle 2',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Molle 2',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Molle 2',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Molle 2',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Molle 2',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Molle 2',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Molle 2',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Molle 2',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/',
          name: 'Molle 3',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
      ],
    },
    {
      name: 'Dardhe',
      related: [
        {
          image: 'http://lorempixel.com/400/400/food/1',
          name: 'Dardhe 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/2',
          name: 'Dardhe 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/5',
          name: 'Dardhe 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/6',
          name: 'Dardhe 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/',
          name: 'Dardhe 3',
          price: 100,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
      ],
    },
    {
      name: 'Veze',
      related: [
        {
          image: 'http://lorempixel.com/400/400/food/1',
          name: 'Veze 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Veze 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/4',
          name: 'Veze 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/1',
          name: 'Veze 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/2',
          name: 'Veze 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/7',
          name: 'Veze 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/8',
          name: 'Veze 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Veze 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },

        {
          image: 'http://lorempixel.com/400/400/food/1',
          name: 'Veze 3',
          price: 100,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
      ],
    },
    {
      name: 'Vere',
      related: [
        {
          image: 'http://lorempixel.com/400/400/food/4',
          name: 'Vere 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Vere 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/2',
          name: 'Vere 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/1',
          name: 'Vere 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/8',
          name: 'Vere 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/7',
          name: 'Vere 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/6',
          name: 'Vere 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/5',
          name: 'Vere 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/4',
          name: 'Vere 3',
          price: 100,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
      ],
    },
    {
      name: 'Domate',
      related: [
        {
          image: 'http://lorempixel.com/400/400/food/7',
          name: 'Domate 1',
          price: 200,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/8',
          name: 'Domate 2',
          price: 10,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/9',
          name: 'Domate 3',
          price: 100,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/4',
          name: 'Domate 3',
          price: 100,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
        {
          image: 'http://lorempixel.com/400/400/food/3',
          name: 'Domate 3',
          price: 100,
          description: 'Molle 2Kg jeshile Test test test testt',
          sector: 'http://amazon.com',
        },
      ],
    },
  ]
}
